import React from 'react'
import {FieldPickerType} from "../../../render/picker"

// const debug = "FieldProto_PickerValueEmpty"
const debug = false

export default function FieldProto_PickerValueEmpty(props: any) {

    debug && console.log(debug, 'render', props)

    switch (props.type) {
        case FieldPickerType.CIRCLE: {
            const classes       = Classes("ui5-circle-selector not-set", props.className)
            const iconClasses   = Classes("icon", props.field.icon)
            return (
                <div className  = {classes}
                     onClick    = {props.onClick}
                >
                    <div className={iconClasses}/>
                    {props.children}
                </div>
            )
        }

        case FieldPickerType.DEFAULT:
        default                     :
            const classes       = Classes("ui5-field-picker is-empty", props.className)
            const iconClasses   = Classes("icon", props.field.icon, props.options?.iconClass)
            return (
                <div className  = {classes}
                     onClick    = {props.onClick}
                >
                    <div className={iconClasses}/>
                    {props.children}
                </div>
            )

    }
}
